namespace $.$$ {

	const $shm_hitalama_map_pane_pencil_cursor_path = 'M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z'
	const $shm_hitalama_map_pane_rect_cursor_path = 'M4,6V19H20V6H4M18,17H6V8H18V17Z'
	const $shm_hitalama_map_pane_circle_cursor_path = 'M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z'

	function $shm_hitalama_map_pane_svg_cursor( path: string, hotspot_x = 8, hotspot_y = 8 ) {
		const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="${ path }" fill="none" stroke="black" stroke-width="3" stroke-linejoin="round"/><path d="${ path }" fill="white"/></svg>`
		return `url("data:image/svg+xml,${ encodeURIComponent( svg ) }") ${ hotspot_x } ${ hotspot_y }, crosshair`
	}

	export class $shm_hitalama_map_pane extends $.$shm_hitalama_map_pane {

		selection_feedback_views() {
			if( !this.$.$shm_hitalama_settings_interface.touch_hints_enabled() ) return []
			return this.selection_feedback_state() ? [ this.Selection_feedback() ] : []
		}

		selection_feedback_state() {
			return ( this.Touch() as $shm_hitalama_map_touch ).selection_feedback()
		}

		selection_feedback_point() {
			return this.selection_feedback_state()?.point ?? [ 0, 0 ]
		}

		selection_feedback_active() {
			return this.selection_feedback_state()?.active ?? false
		}

		selection_feedback_moving() {
			return this.selection_feedback_state()?.moving ?? false
		}

		camera_state_key() {
			return this.toString()
		}

		camera_zoom_default() {
			const zoom = Number( this.$.$mol_state_local.value( this.toString() + 'zoom' ) ?? 1 )
			return Number.isFinite( zoom ) ? zoom : 1
		}

		camera_shift_default() {
			const shift = this.$.$mol_state_local.value( this.toString() + 'shift' ) as [number, number] | null
			return new this.$.$mol_vector_2d( ...(shift ?? [100,100]) )
		}

		select_move_listener?: $mol_dom_listener
		select_end_listener?: $mol_dom_listener

		select_finish() {
			this.select_move_listener?.destructor()
			this.select_end_listener?.destructor()
			this.select_move_listener = undefined
			this.select_end_listener = undefined
			this.selecting( false )
		}

		destructor() {
			this.select_finish()
			super.destructor()
		}

		@ $mol_action
		select_start( event: PointerEvent ) {
			if( this.Map_page().interaction_locked() ) return
			if( event?.button !== 0 ) return
			this.select_touch_start( event )

			this.select_move_listener = new $mol_dom_listener(
				this.$.$mol_dom_context.document,
				'mousemove',
				event => {
					if( !( event.buttons & 1 ) ) {
						this.select_finish()
						return
					}
					this.select_rect_end_x( event.clientX )
					this.select_rect_end_y( event.clientY )
					$mol_wire_async( this.Map_page() ).select_resize()
				},
			)

			this.select_end_listener = new $mol_dom_listener(
				this.$.$mol_dom_context.document,
				'mouseup',
				()=> this.select_finish(),
			)
		}

		select_touch_start( event: PointerEvent ) {
			if( this.Map_page().interaction_locked() ) return
			this.select_finish()
			this.selecting( true )
			this.select_rect_start_x( event.clientX )
			this.select_rect_start_y( event.clientY )
			this.select_rect_end_x( event.clientX )
			this.select_rect_end_y( event.clientY )
		}

		select_touch_move( event: PointerEvent ) {
			this.select_rect_end_x( event.clientX )
			this.select_rect_end_y( event.clientY )
			$mol_wire_async( this.Map_page() ).select_resize()
		}
		
		@ $mol_mem
		pointer_client_pos( next?: readonly [ number, number ] ): readonly [ number, number ] {
			return next ?? [ 0, 0 ]
		}

		pointer_move( event?: PointerEvent ) {
			if( this.tool_mode_active() ) {
				this.Tool().event_move( event! )
				return
			}
			this.drag_mode_sync_from_pointer_event( event )
			this.pointer_client_pos( [ event!.clientX, event!.clientY ] )
		}

		pointer_down( event?: PointerEvent ) {
			if( this.Map_page().interaction_locked() ) return
			if( this.tool_mode_active() ) {
				if( event?.button === 2 ) this.tool_contextmenu_start = event
				else this.Tool().event_start( event! )
				return
			}
			this.drag_mode_sync_from_pointer_event( event )
			if( event?.button == 2 ) {
				this.viewport_shifting( true )
			}
		}

		back_event_pointerdown( event?: PointerEvent ) {
			if( this.tool_mode_active() ) {
				if( event?.button === 2 ) this.tool_contextmenu_start = event
				else this.Tool().event_start( event! )
				return
			}
			return super.back_event_pointerdown( event )
		}

		drag_mode_key() {
			return this.$.$shm_hitalama_settings.drag_mode_key()
		}

		drag_mode_key_is_modifier() {
			return [ 'Control', 'Shift', 'Alt', 'Meta' ].includes( this.drag_mode_key() )
		}

		drag_mode_enabled_from_event( event?: Pick< KeyboardEvent, 'key' | 'getModifierState' > | Pick< PointerEvent, 'ctrlKey' | 'shiftKey' | 'altKey' | 'metaKey' > | null ) {
			if( !event ) return false

			const key = this.drag_mode_key()
			if( 'key' in event ) {
				if( this.drag_mode_key_is_modifier() ) return event.getModifierState?.( key ) ?? event.key === key
				return event.key === key
			}
			if( key === 'Control' ) return event.ctrlKey
			if( key === 'Shift' ) return event.shiftKey
			if( key === 'Alt' ) return event.altKey
			if( key === 'Meta' ) return event.metaKey

			return false
		}

		drag_mode_sync_from_pointer_event( event?: PointerEvent ) {
			if( this.Map_page().interaction_locked() ) {
				this.drag_mode_enabled( false )
				return
			}
			if( !this.drag_mode_key() ) {
				this.drag_mode_enabled( false )
				return
			}
			if( !this.drag_mode_key_is_modifier() ) return
			this.drag_mode_enabled( this.drag_mode_enabled_from_event( event ) )
		}

		allow_pan() {
			if( this.touch_event_disabled() ) return false
			return true
		}

		allow_zoom() {
			if( this.touch_event_disabled() ) return false
			return this.viewport_shifting() || this.ctrl_pressed()
		}

		allow_touch_zoom() {
			return !this.touch_event_disabled()
		}

		pointer_up( event?: PointerEvent ) {
			if( this.tool_mode_active() ) {
				if( event?.button !== 2 ) this.Tool().event_end( event! )
				return
			}
			this.drag_mode_sync_from_pointer_event( event )
			if( event?.button == 2 ) this.viewport_shifting( false )
		}

		tool_contextmenu_start?: PointerEvent
		pane_contextmenu( event?: MouseEvent ) {
			if( this.Map_page().overlayed() ) return
			event?.preventDefault()
			if( ( event as PointerEvent )?.pointerType === 'touch' ) return
			if( !this.tool_mode_active() ) return

			const start = this.tool_contextmenu_start
			this.tool_contextmenu_start = undefined
			if( start && event && $shm_hitalama_is_panning( start, event as PointerEvent ) ) return

			this.Map_page().tool_mode( '' )
		}

		@ $mol_mem
		pointer_pos(): readonly [ number, number ] {
			return this.client_pos_to_pane_pos( this.pointer_client_pos() )
		}

		@ $mol_mem
		real_pointer_pos(): readonly ( any )[] {
			return this.to_real_pos( this.pointer_pos() )
		}

		to_real_pos( [x,y]: readonly [number, number] ) {
			const shift = this.shift()
			const zoom = this.zoom()
			return [
				(x - shift[0])/zoom,
				(y - shift[1])/zoom,
			]
		}

		client_pos_to_pane_pos( client_pos: readonly [ number, number ] | readonly number[] ) {
			const { left, top } = this.dom_node().getBoundingClientRect()
			let x = client_pos[0] - left
			let y = client_pos[1] - top

			return [ x, y ] as const
		}
	
		select_rect() {
			return this.selecting() ? super.select_rect() : []
		}

		select_rect_pos() {
			return this.client_pos_to_pane_pos([
				Math.min( this.select_rect_start_x(), this.select_rect_end_x() ),
				Math.min( this.select_rect_start_y(), this.select_rect_end_y() ),
			])
		}

		select_rect_size() {
			return [
				Math.abs( this.select_rect_end_x() - this.select_rect_start_x() ),
				Math.abs( this.select_rect_end_y() - this.select_rect_start_y() ),
			]
		}

		@ $mol_mem
		select_rect_left(): string {
			return this.select_rect_pos()[0] + 'px'
		}

		@ $mol_mem
		select_rect_top(): string {
			return this.select_rect_pos()[1] + 'px'
		}

		@ $mol_mem
		select_rect_width(): string {
			return this.select_rect_size()[0] + 'px'
		}

		@ $mol_mem
		select_rect_height(): string {
			return this.select_rect_size()[1] + 'px'
		}

		@ $mol_mem
		transform() {
			const [ shift_x, shift_y ] = this.shift()
			const scale = this.zoom()
			const pos_x = shift_x
			const pos_y = shift_y
			return `translate3d(${ pos_x }px,${ pos_y }px,0px) scale(${ scale })`
		}

		cursor_style() {
			switch( this.tool_mode() ) {
				case 'drawing': return $shm_hitalama_map_pane_svg_cursor( $shm_hitalama_map_pane_pencil_cursor_path, 2, 14 )
				case 'rect': return $shm_hitalama_map_pane_svg_cursor( $shm_hitalama_map_pane_rect_cursor_path )
				case 'circle': return $shm_hitalama_map_pane_svg_cursor( $shm_hitalama_map_pane_circle_cursor_path )
				default: return ''
			}
		}

		tool_mode_active() {
			return this.tool_mode() !== ''
		}

		@ $mol_mem
		zoom( next?: number ) {
			return this.Camera_url().zoom( next )
		}

		@ $mol_mem
		shift( next?: $mol_vector_2d<number> ): $mol_vector_2d<number> {
			return this.Camera_url().shift( next )
		}
		
		@ $mol_mem
		blur_handler() {
			return $mol_wire_async( ( event: Event ) => {
				this.select_finish()
				this.drag_mode_enabled( false )
				this.ctrl_pressed( false )
				this.shift_pressed( false )
			} )
		}

		@ $mol_mem
		visibilitychange_handler() {
			return $mol_wire_async( ( event: Event ) => {
				if( !this.document().hidden ) return
				this.select_finish()
				this.drag_mode_enabled( false )
				this.ctrl_pressed( false )
				this.shift_pressed( false )
			} )
		}

		@ $mol_mem
		keydown_handler() {
			return $mol_wire_async( ( event: KeyboardEvent ) => {
				if( this.Map_page().interaction_locked() ) return
				if( this.drag_mode_enabled_from_event( event ) ) {
					this.drag_mode_enabled( true )
				}
				if( event.key == 'Control' ) {
					this.ctrl_pressed( true )
				}
				else if( event.key == 'Shift' ) {
					this.shift_pressed( true )
				}
			} )
		}

		@ $mol_mem
		keyup_handler() {
			return $mol_wire_async( ( event: KeyboardEvent ) => {
				if( event.key == this.drag_mode_key() ) {
					this.drag_mode_enabled( false )
				}
				if( event.key == 'Control' ) {
					this.ctrl_pressed( false )
				}
				else if( event.key == 'Shift' ) {
					this.shift_pressed( false )
				}
			} )
		}

		document() {
			return this.$.$mol_dom_context.document
		}

		window() {
			return this.$.$mol_dom_context.window
		}

		wheel( event: WheelEvent ) {
			if( this.touch_event_disabled() ) {
				return
			}

			this.ctrl_pressed( event.ctrlKey )
			this.shift_pressed( event.shiftKey )

			if( this.viewport_shifting() || this.ctrl_pressed() ) return

			let prevent_shift_x = wheel_prevent_shift_x( event )
			let prevent_shift_y = wheel_prevent_shift_y( event )

			if( this.drag_mode_enabled() ) {
				prevent_shift_x = false
				prevent_shift_y = false
			}

			if( !prevent_shift_x && !prevent_shift_y ) {
				this.drag_mode_enabled( true )
			}

			// if( !prevent_shift_x || !prevent_shift_y ) {
			// 	event.preventDefault()
			// }
			
			const shift = this.shift()
			if( this.shift_pressed() && (Math.abs(event.deltaX) == 0) ) {

				if( prevent_shift_x ) return
				this.shift( new this.$.$mol_vector_2d( shift.x - event.deltaY, shift.y ) )

			} else {
				this.shift( new this.$.$mol_vector_2d(
					shift.x - (prevent_shift_x ? 0 : event.deltaX),
					shift.y - (prevent_shift_y ? 0 : event.deltaY),
				) )
			}
			
		}

		@ $mol_mem
		content_pointer_events(): string {
			return this.drag_mode_enabled() ? 'none' : 'auto'
		}

		scale() {
			return new $mol_vector_2d( this.zoom(), this.zoom() )
		}

		@ $mol_mem
		dimensions_viewport() {
			const shift = this.shift().multed0(-1)
			const scale = this.scale().powered0(-1)
			return this.viewport().map( ( range, i )=> range.added0( shift[i] ).multed0( scale[i] ).sort( (a,b)=>a-b) )
		}

		@ $mol_mem
		viewport() {
			const size = this.view_rect_ensured()
			const x = size?.width
			const y = size?.height
			return new this.$.$mol_vector_2d(
				new this.$.$mol_vector_range(0, x),
				new this.$.$mol_vector_range(0, y),
			)
		}

		@ $mol_mem
		view_rect_ensured() {
			let view_rect = this.Back().view_rect()
			if( view_rect ) return view_rect
			this.$.$mol_wait_timeout( 1000 )
			return null
		}
		
		@ $mol_mem
		box_in_viewport( box?: $mol_vector_2d< $mol_vector_range< number > > ) {
			let view_rect = $mol_wire_sync( this ).view_rect_ensured()
			if( !view_rect ) return this.dimensions_viewport()

			if( box === undefined ) return this.dimensions_viewport()

			const { zoom, shift_x, shift_y } = this.$.$shm_hitalama_map_pane_box_shift( { box, view_rect } )
			this.shift_viewport_smooth( zoom, shift_x, shift_y )
			
			return box
		}

		@ $mol_action
		center_to_point( [ c_x, c_y ]: number[] ) {
			const rect = $mol_wire_sync( this ).view_rect_ensured()
			if( !rect ) return
			const { width, height } = rect

			const shift_x_next = width/2 - ( c_x * this.zoom() )
			const shift_y_next = height/2 - ( c_y * this.zoom() )
			
			this.shift_viewport_smooth( this.zoom(), shift_x_next, shift_y_next )
		}

		shift_viewport_duration = 600
		shift_viewport_tick?: ( timestamp: number ) => void
		@ $mol_action
		shift_viewport_smooth( zoom: number, shift_x: number, shift_y: number ) {

			const zoom_start = this.zoom()
			const zoom_diff = zoom - zoom_start
			
			const shift_x_start = this.shift().x
			const shift_x_diff = shift_x - shift_x_start

			const shift_y_start = this.shift().y
			const shift_y_diff = shift_y - shift_y_start

			let start: number | undefined = undefined

			this.shift_viewport_tick = ( timestamp )=> {
				start = start ?? timestamp
				
				const elapsed = timestamp - start
				const fraction = Math.min( elapsed / this.shift_viewport_duration, 1 )

				this.zoom( zoom_start + zoom_diff * fraction )
				this.shift( new $mol_vector_2d(
					shift_x_start + shift_x_diff * fraction,
					shift_y_start + shift_y_diff * fraction,
				) )

				if( fraction < 1 ) requestAnimationFrame( this.shift_viewport_tick! )
			}
			requestAnimationFrame( this.shift_viewport_tick )

		}

	}
	
	export function $shm_hitalama_map_pane_box_shift( { box, view_rect, zoom } : {
		box: $mol_vector_2d< $mol_vector_range< number > >,
		view_rect: { width: number, height: number, left: number, right: number, top: number, bottom: number },
		zoom?: number,
	} ) {
		const { width, height, left } = view_rect

		const box_dx = box.x.max - box.x.min
		const box_dy = box.y.max - box.y.min

		const box_ratio = box_dx / box_dy
		const rect_ratio = width / height

		zoom = zoom ?? ( box_ratio > rect_ratio
			? width / box_dx
			: height / box_dy )

		const shift_x = - ( box.x.min + box_dx/2 ) * zoom + width/2
		const shift_y = - ( box.y.min + box_dy/2 ) * zoom + height/2

		return { zoom, shift_x, shift_y }
	}

	function has_scrollbar_y( el: Element ) {
		const style = window.getComputedStyle( el )
		if( ![ 'auto', 'scroll', 'overlay' ].includes( style.overflowY ) ) return false
		return el.scrollHeight > el.clientHeight
	}

	function has_scrollbar_x( el: Element ) {
		const style = window.getComputedStyle( el )
		if( ![ 'auto', 'scroll', 'overlay' ].includes( style.overflowX ) ) return false
		return el.scrollWidth > el.clientWidth
	}

	function wheel_prevent_shift_x( event: WheelEvent ) {
		for( const target of event.composedPath() ) {
			if( !(target instanceof HTMLElement) ) continue
			if( target.nodeName == 'HITALAMA_MAP_PANE' ) return false
			if( has_scrollbar_x( target ) ) return true
		}
		return false
	}

	function wheel_prevent_shift_y( event: WheelEvent ) {
		for( const target of event.composedPath() ) {
			if( !(target instanceof HTMLElement) ) continue
			if( target.nodeName == 'HITALAMA_MAP_PANE' ) return false
			if( has_scrollbar_y( target ) ) return true
		}
		return false
	}

}
